import { useState, useEffect } from 'react';
import { blogsAPI, poemsAPI, galleryAPI, productsAPI, ordersAPI } from '../services/api';

export const useAPI = (collectionName) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get the appropriate API based on collection name
  const getAPI = () => {
    switch (collectionName) {
      case 'blogs':
        return blogsAPI;
      case 'poems':
        return poemsAPI;
      case 'gallery':
        return galleryAPI;
      case 'products':
        return productsAPI;
      case 'orders':
        return ordersAPI;
      default:
        throw new Error(`Unknown collection: ${collectionName}`);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const api = getAPI();
      const response = await api.getAll();
      
      const extractedData = response.data?.data || response.data || [];
      
      setData(extractedData);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  const addItem = async (item) => {
    try {
      const api = getAPI();
      const response = await api.create(item);
      await fetchData(); // Refresh data
      return response.data._id || response.data.id;
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Error creating item');
      throw err;
    }
  };

  const updateItem = async (id, updates) => {
    try {
      const api = getAPI();
      await api.update(id, updates);
      await fetchData();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Error updating item');
      throw err;
    }
  };

  const deleteItem = async (id) => {
    try {
      const api = getAPI();
      await api.delete(id);
      await fetchData();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Error deleting item');
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, [collectionName]);

  return {
    data,
    loading,
    error,
    addItem,
    updateItem,
    deleteItem,
    refetch: fetchData
  };
};
